import NumberFormat from 'react-currency-format';
import PropTypes from 'prop-types';

import { FormGroup, Input, Label } from "reactstrap";

const PortabilityData = ({ onChangeInput, values }) => (
  <div className='crm-case-form-container'>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="nameEF">Nombre entidad financiera original:</Label>
        <Input
          type="text"
          name="nameEF"
          id="nameEF"
          className="newArea"
          disabled
          value={values.nameEF}
          onChange={onChangeInput('nameEF')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="financialProducts">Productos financieros vigentes con finalidad original:</Label>
        <Input
          type="text"
          name="financialProducts"
          id="financialProducts"
          className="newArea"
          disabled
          value={values.financialProducts}
          onChange={onChangeInput('financialProducts')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="financialProductsToImport">Productos financieros vigentes a portar:</Label>
        <Input
          type="text"
          name="financialProductsToImport"
          id="financialProductsToImport"
          className="newArea"
          disabled
          value={values.financialProductsToImport}
          onChange={onChangeInput('financialProductsToImport')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup className="columend_date">
        <Label className="label_autofin" for="originalFeeValue">Valor cuota original:</Label>
        <NumberFormat
          style={{ border: '1px solid #ced4da', borderRadius: '0.25rem' }}
          prefix="$"
          min="0"
          name="originalFeeValue"
          id="rent"
          max="99999999"
          className="newArea"
          decimalSeparator=","
          thousandSeparator="."
          value={values.originalFeeValue}
          disabled={true}
          onChange={onChangeInput('originalFeeValue')}
        />
      </FormGroup>
    </div>
    <div hidden>
      <FormGroup>
        <Label className="label_autofin" for="originalCreditAmount">Monto original credito:</Label>
        <Input
          type="text"
          name="originalCreditAmount"
          id="originalCreditAmount"
          className="newArea"
          disabled
          value={values.originalCreditAmount}
          onChange={onChangeInput('originalCreditAmount')}
        />
      </FormGroup>
    </div>
    <div hidden>
      <FormGroup>
        <Label className="label_autofin" for="originalPeriod">Plazo original:</Label>
        <Input
          type="text"
          name="originalPeriod"
          id="originalPeriod"
          className="newArea"
          disabled
          value={values.originalPeriod}
          onChange={onChangeInput('originalPeriod')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="totalPaidFees">Cantidad de cuotas pagadas:</Label>
        <Input
          type="text"
          name="totalPaidFees"
          id="totalPaidFees"
          className="newArea"
          disabled
          value={values.totalPaidFees}
          onChange={onChangeInput('totalPaidFees')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="licensePlate">Patente:</Label>
        <Input
          type="text"
          name="licensePlate"
          id="licensePlate"
          className="newArea"
          disabled
          value={values.licensePlate}
          onChange={onChangeInput('licensePlate')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup className='form-group-textarea'>
        <Label className="label_autofin" for="description">Descripción:</Label>
        <Input
          type="textarea"
          name="description"
          id="description"
          className="newArea"
          disabled
          value={values.description}
          onChange={onChangeInput('description')}
        />
      </FormGroup>
    </div>
  </div>
);

PortabilityData.propTypes = {
  onChangeInput: PropTypes.func.isRequired,
  values: PropTypes.shape({
    nameEF: PropTypes.string,
    description: PropTypes.string,
    licensePlate: PropTypes.string,
    totalPaidFees: PropTypes.string,
    originalPeriod: PropTypes.string,
    financialProducts: PropTypes.string,
    financialProductsToImport: PropTypes.string,
    originalFeeValue: PropTypes.number,
    originalCreditAmount: PropTypes.number,
  }).isRequired,
};

export default PortabilityData;